import { ICommonSettings, IConfig } from "@kuika/kuika-cl-model";

export const SET_GLOBAL_CONFIGS = "SET_GLOBAL_CONFIGS";
export const SET_CONFIG_LOCALIZATIONS = "SET_CONFIG_LOCALIZATIONS";
export const SET_ACTIVE_GLOBAL_CONFIGURATION = "SET_ACTIVE_GLOBAL_CONFIGURATION";
export const SET_GLOBAL_CONFIGS_LOADING_STATUS = "SET_GLOBAL_CONFIGS_LOADING_STATUS";
export const CREATE_GLOBAL_CONFIG = "CREATE_GLOBAL_CONFIG";

export interface GlobalConfigModuleState {
  activeGlobalConfiguration?: IConfig;
  globalConfigs: IConfig[];
  globalCommonSettings: ICommonSettings;
  isGlobalConfigsLoading: boolean;
  isCreateGlobalConfigActive: boolean;
}

export interface SetGlobalConfigsAction {
  type: typeof SET_GLOBAL_CONFIGS;
  meta: {
    params: {
      globalConfigs: GlobalConfigModuleState["globalConfigs"];
      globalCommonSettings: GlobalConfigModuleState["globalCommonSettings"];
    };
  };
}

export interface SetActiveGlobalConfig {
  type: typeof SET_ACTIVE_GLOBAL_CONFIGURATION;
  meta: {
    params: {
      activeGlobalConfiguration: GlobalConfigModuleState["activeGlobalConfiguration"];
    };
  };
}

export interface SetGlobalConfigsLoadingStatus {
  type: typeof SET_GLOBAL_CONFIGS_LOADING_STATUS;
  meta: {
    params: {
      isGlobalConfigsLoading: GlobalConfigModuleState["isGlobalConfigsLoading"];
    };
  };
}

export interface CreateGlobalConfig {
  type: typeof CREATE_GLOBAL_CONFIG;
  meta: {
    params: {
      name: string;
    };
  };
}

export type GlobalConfigModuleActionTypes =
  | SetGlobalConfigsAction
  | SetActiveGlobalConfig
  | SetGlobalConfigsLoadingStatus
  | CreateGlobalConfig;
